import { Anchor } from '@mantine/core';
import { ReactNode } from 'react';
import Tooltip from 'src/components/UI/Tooltip/Tooltip';

export const LIMITED_EDITOR_TOOLTIP_SPAN_STYLE: React.CSSProperties = {
	display: 'block',
	textAlign: 'center',
	fontFamily: 'Open Sans',
	fontWeight: 400,
	fontSize: 10,
	lineHeight: '14px',
	letterSpacing: '0.11px'
};

export const LIMITED_EDITOR_TOOLTIP_ANCHOR_STYLE: React.CSSProperties = {
	color: 'inherit',
	fontFamily: 'Open Sans',
	fontWeight: 400,
	fontSize: 10,
	lineHeight: '14px',
	letterSpacing: '0.11px',
	textDecoration: 'underline',
	textDecorationColor: 'rgba(255,255,255,0.4)'
};

type LimitedEditorPaywallTooltipProps = {
	onRequestSeat: () => void;
	children: ReactNode;
};

const LimitedEditorPaywallTooltip = ( { onRequestSeat, children }: LimitedEditorPaywallTooltipProps ) => (
	<Tooltip
		interactive
		position="bottom"
		html={(
			<span style={LIMITED_EDITOR_TOOLTIP_SPAN_STYLE}>
				Only workspace members can have full<br />Editor permissions.<br />
				<Anchor component="button" onClick={onRequestSeat} style={LIMITED_EDITOR_TOOLTIP_ANCHOR_STYLE}>
					Request a seat.
				</Anchor>
			</span>
		)}
	>
		{children}
	</Tooltip>
);

export default LimitedEditorPaywallTooltip;
